// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"537":"a51b6a5e7c19b819bb6f","864":"425622af70b195ff3fa1"}[chunkId] + ".css";
};